import React, { MouseEventHandler } from "react";
import { T } from "services/lang/LanguageService";
import useIsMobile from "hooks/useIsMobile";
import { DashboardLayoutType, IDashboardComponent } from "api/model/dashboard/DashboardComponent";
import DashboardComponent from "../../group-component/GroupComponent";
import { ContextMenuItem } from "../interfaces";
import "../Layout.scss";

interface VerticalLayoutProps {
  components: IDashboardComponent[];
  align?: string;
  layoutType: DashboardLayoutType;
  groupId: string;
  isEditMode: boolean;
  onContextMenu: MouseEventHandler<HTMLDivElement>;
  setCurrentContextMenuItems: (currentContextMenuItems: ContextMenuItem[]) => void;
}

const VerticalLayout = ({
  components,
  align,
  layoutType,
  groupId,
  isEditMode,
  onContextMenu,
  setCurrentContextMenuItems,
}: VerticalLayoutProps) => {
  const isMobile = useIsMobile();

  const getComponentWidth = (component: IDashboardComponent) => {
    if (isMobile || component.type === "SEPARATOR") {
      return 12;
    }
    return component.layout?.VERTICAL?.width ?? 6;
  };

  const getComponentHeight = (component: IDashboardComponent) => {
    if (component.type === "NOT_SUPPORTED") {
      return 200;
    }
    return component.layout?.VERTICAL?.height ?? "100%";
  };

  return (
    <div className={`flex flex-column align-items-${align?.toLowerCase()} w-full`}>
      {components?.length > 0 ? (
        components.map(component => (
          <div
            key={component.id}
            onContextMenu={onContextMenu}
            className={`w-${getComponentWidth(component)} layout-wrapper vertical-layout`}
            style={{
              height: getComponentHeight(component),
            }}
          >
            <DashboardComponent
              groupId={groupId}
              component={component}
              layoutType={layoutType}
              setCurrentContextMenuItems={setCurrentContextMenuItems}
              isEditMode={isEditMode}
            />
          </div>
        ))
      ) : (
        <div className="pl-3">{T("error.group-has-no-components")}</div>
      )}
    </div>
  );
};

export default VerticalLayout;
